import { useEffect } from 'react'
import { useAppSetting, useUpdateAppSetting } from '@/components/appStore'

/**
 * @description 同步本地持久化存储的多语言设置与URL中的多语言参数
 * 该 Hook 用于确保应用程序的语言设置与 URL 中指定的语言参数保持一致。
 * 如果 URL 中的语言参数与本地存储的语言设置不一致，则更新本地存储。
 * @param {string} lang - URL 中指定的语言参数
 */
const useSyncLocaleWithURL = (lang: string) => {
  const locale = useAppSetting('locale')
  const updateAppSetting = useUpdateAppSetting()

  useEffect(() => {
    if (locale !== lang) {
      updateAppSetting('locale', lang)
    }
  }, [lang, locale, updateAppSetting])
}

export default useSyncLocaleWithURL
